import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import {
  Chart,
  ChartData,
  ChartDataset,
  ChartType
} from 'chart.js';
import ChartDataLabels, { Context as DataLabelContext } from 'chartjs-plugin-datalabels';
import { BaseChartDirective } from 'ng2-charts';
import { ExpertCalibration_Interface } from 'src/app/Interface/ExpertCalibration_Interface';
import { Kartable_Device_Point_Interface } from 'src/app/Interface/Kartable_Device_Point_Interface';
import { User_Interface } from 'src/app/Interface/User_Interface';
import { DevicePoint2YearItem, DevicePoint2WorkingItem, DevicePoint2YearsResponse, KartableService } from 'src/app/Service/Kartable/Kartable.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { UserService } from 'src/app/Service/User/User.service';
import * as XLSX from 'xlsx';

interface Chart1Item {
  fullName: string;
  totalT4: number;
}

interface Chart2Item {
  fullName: string;
  year: number;
  month: number;
  monthName: string;
  totalT4: number;
}
interface DevicePoint2ApiResponse {
  reuslt?: Kartable_Device_Point_Interface[];
  chart1?: Chart1Item[];
  chart2?: Chart2Item[];
  workday?: number;
}

interface Chart2MonthMeta {
  year: number;
  month: number;
  monthName: string;
  displayLabel: string;
}

interface DatasetColorPair {
  background: string;
  border: string;
}

interface RoundedRectangleModel {
  x: number;
  y: number;
  base: number;
  width: number;
  backgroundColor: string | CanvasGradient | CanvasPattern;
  borderColor: string | CanvasGradient | CanvasPattern;
  borderWidth: number;
}

interface RoundedRectangleElement {
  _chart: {
    ctx: CanvasRenderingContext2D;
  };
  _view: RoundedRectangleModel;
  draw: () => void;
}

interface ChartWithRoundedBars {
  elements?: {
    Rectangle?: {
      prototype: RoundedRectangleElement;
    };
  };
}

const DATA_LABELS_PLUGIN = ChartDataLabels as any;
const CHART_FONT_FAMILY = "'yekan', 'Segoe UI', Tahoma, sans-serif";
const CHART_TEXT_COLOR = '#334155';
const CHART_AXIS_FONT_SIZE = 12;
const CHART_TITLE_FONT_SIZE = 16;
const CHART_LABEL_FONT_SIZE = 12;
const CHART_TOOLTIP_FONT_SIZE = 13;
const CHART_SCALE_PADDING_RATIO = 0.1;
const CHART_SCALE_MIN_PADDING = 1;
const HORIZONTAL_LINE_LABEL_PADDING = 6;
const HORIZONTAL_LINE_LABEL_HEIGHT = 24;

interface ChartJs2Scale {
  getPixelForValue(value: number): number;
}

interface ChartJs2WithArea {
  ctx: CanvasRenderingContext2D;
  chartArea?: { left: number; right: number; top: number; bottom: number };
  scales?: { [key: string]: ChartJs2Scale };
}

registerRoundedBarCorners();

function registerRoundedBarCorners(): void {
  const chartWithRoundedBars = Chart as unknown as ChartWithRoundedBars;
  const rectanglePrototype = chartWithRoundedBars.elements?.Rectangle?.prototype;

  if (!rectanglePrototype) {
    return;
  }

  rectanglePrototype.draw = function drawRoundedBar(this: RoundedRectangleElement): void {
    const ctx = this._chart.ctx;
    const view = this._view;
    const left = view.x - view.width / 2;
    const right = view.x + view.width / 2;
    const top = Math.min(view.y, view.base);
    const bottom = Math.max(view.y, view.base);
    const radius = Math.min(6, view.width / 2, Math.abs(bottom - top) / 2);

    ctx.save();
    ctx.beginPath();
    ctx.fillStyle = view.backgroundColor;
    ctx.strokeStyle = view.borderColor;
    ctx.lineWidth = view.borderWidth || 0;
    ctx.moveTo(left, bottom);
    ctx.lineTo(left, top + radius);
    ctx.quadraticCurveTo(left, top, left + radius, top);
    ctx.lineTo(right - radius, top);
    ctx.quadraticCurveTo(right, top, right, top + radius);
    ctx.lineTo(right, bottom);
    ctx.closePath();
    ctx.fill();

    if (view.borderWidth) {
      ctx.stroke();
    }

    ctx.restore();
  };
}

@Component({
  selector: 'app-KartableDevicePoint2',
  templateUrl: './KartableDevicePoint2.component.html',
  styleUrls: ['./KartableDevicePoint2.component.scss']
})
export class KartableDevicePoint2Component implements OnInit {

  @ViewChild('chart1Chart', { static: false })
  private chart1Directive?: BaseChartDirective;
  @ViewChild('devicePoint2YearsChart', { static: false })
  private devicePoint2YearsChartDirective?: BaseChartDirective;

  Token = '';

  CustomerName = '';
  DeviceName = '';
  SubmitPeriodDate = '1';
  SubmitAccept = '0';
  LocationOfCalibration = '0';
  page = 0;
  pmPage = 0;

  Procssing = false;

  DataList_Kartable: Kartable_Device_Point_Interface[] = [];
  DataList_Calibration: Kartable_Device_Point_Interface[] = [];
  DataList_PM_V2: Kartable_Device_Point_Interface[] = [];
  DataList_Kartable_Option: User_Interface[] = [];

  ExpertCalibration = '';

  chart1HasData = false;
  chart2HasData = false;
  chart1Legend = false;
  chart2Legend = true;
  chart1MinWidth = '100%';
  chart2MinWidth = '100%';
  chart2MonthMeta: Chart2MonthMeta[] = [];

  readonly barChartType: ChartType = 'bar';
  readonly chart2Plugins: any[] = [DATA_LABELS_PLUGIN];

  public readonly persianMonths = ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'];
  public isLoadingDevicePoint2Years = false;
  public devicePoint2YearsLoaded = false;
  public devicePoint2YearsChartHasData = false;
  public devicePoint2YearFullNames: string[] = [];
  public selectedDevicePoint2YearFullName = '';
  public devicePoint2YearsChartData: ChartDataset[] = [];
  public readonly devicePoint2YearsChartMinWidth = '1100px';
  public currentYearWorkingValues: Array<number | null> = new Array<number | null>(12).fill(null);
  public lastYearWorkingValues: Array<number | null> = new Array<number | null>(12).fill(null);
  public devicePoint2YearsResponse: DevicePoint2YearsResponse | null = null;
  public devicePoint2YearsChartOptions: any = this.createDevicePoint2YearsChartOptions();

  public chart1HorizontalLineValue: number | null = 50;
  public chart1HorizontalLineColor = '#d32f2f';
  public chart1HorizontalLineWidth = 2;
  public chart1HorizontalLineDash: number[] = [6, 4];
  public chart1HorizontalLineLabel = 'حد مجاز';

  readonly chart1Plugins: any[] = [
    DATA_LABELS_PLUGIN,
    {
      id: 'kartable-chart1-horizontal-line',
      afterDatasetsDraw: (chart: ChartJs2WithArea) => this.drawChart1HorizontalLine(chart)
    } as any
  ];

  chart1Labels: Array<string | string[]> = [];
  chart2Labels: Array<string | string[]> = [];
  chart1Data: ChartDataset[] = [];
  chart2Data: ChartDataset[] = [];

  chart1Options: any = this.convertLegacyChartOptions({
    responsive: true,
    maintainAspectRatio: false,
    responsiveAnimationDuration: 200,
    layout: {
      padding: {
        top: 18,
        right: 12,
        left: 12,
        bottom: 4
      }
    },
    legend: {
      display: false
    },
    title: {
      display: true,
      text: 'جمع کل T4 به تفکیک کارشناس',
      fontColor: '#0f172a',
      fontFamily: CHART_FONT_FAMILY,
      fontSize: CHART_TITLE_FONT_SIZE,
      fontStyle: 'bold',
      padding: 18
    },
    tooltips: {
      rtl: true,
      titleAlign: 'right',
      bodyAlign: 'right',
      backgroundColor: 'rgba(15, 23, 42, 0.92)',
      titleFontSize: 13,
      titleFontFamily: CHART_FONT_FAMILY,
      bodyFontFamily: CHART_FONT_FAMILY,
      titleFontStyle: 'bold',
      bodyFontSize: CHART_TOOLTIP_FONT_SIZE,
      xPadding: 12,
      yPadding: 10,
      callbacks: {
        title: (tooltipItems: any[], chartData: ChartData) =>
          this.getLabelText(chartData.labels?.[tooltipItems[0]?.index ?? 0]),
        label: (tooltipItem: any) =>
          `T4: ${this.formatNumber(Number(tooltipItem.yLabel ?? 0))}`
      }
    },
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
        offset: 2,
        clamp: true,
        clip: false,
        color: '#1f2937',
        font: {
          family: CHART_FONT_FAMILY,
          size: CHART_LABEL_FONT_SIZE,
          weight: 'bold'
        },
        formatter: (value: number | string | null | undefined) => {
          const numericValue = Number(value ?? 0);
          if (numericValue === 0) {
            return '';
          }
          return this.formatNumber(numericValue);
        },
        display: (context: DataLabelContext) => this.getDataLabelValue(context) !== 0
      }
    },
    scales: {
      xAxes: [
        {
          stacked: false,
          offset: true,
          gridLines: {
            display: false,
            color: '#f1f5f9',
            zeroLineColor: '#cbd5e1'
          },
          ticks: {
            autoSkip: true,
            maxTicksLimit: 16,
            fontFamily: CHART_FONT_FAMILY,
            fontSize: CHART_AXIS_FONT_SIZE,
            fontStyle: 'bold',
            fontColor: CHART_TEXT_COLOR,
            maxRotation: 0,
            minRotation: 0,
            padding: 8
          },
          scaleLabel: {
            display: true,
            labelString: 'نام کارشناس',
            fontFamily: CHART_FONT_FAMILY,
            fontColor: '#334155',
            fontSize: 13,
            fontStyle: 'bold'
          }
        }
      ],
      yAxes: [
        {
          stacked: false,
          gridLines: {
            color: '#e5e7eb',
            zeroLineColor: '#cbd5e1'
          },
          ticks: {
            beginAtZero: true,
            fontFamily: CHART_FONT_FAMILY,
            fontSize: CHART_AXIS_FONT_SIZE,
            fontStyle: 'bold',
            fontColor: CHART_TEXT_COLOR,
            padding: 8,
            callback: (value: string | number) => this.formatNumber(Number(value ?? 0))
          },
          scaleLabel: {
            display: true,
            labelString: 'T4',
            fontFamily: CHART_FONT_FAMILY,
            fontColor: '#334155',
            fontSize: 13,
            fontStyle: 'bold'
          }
        }
      ]
    }
  });

  chart2Options: any = this.convertLegacyChartOptions({
    responsive: true,
    maintainAspectRatio: false,
    responsiveAnimationDuration: 200,
    layout: {
      padding: {
        top: 18,
        right: 12,
        left: 12,
        bottom: 4
      }
    },
    legend: {
      display: true,
      position: 'bottom',
      rtl: true,
      labels: {
        boxWidth: 12,
        fontFamily: CHART_FONT_FAMILY,
        fontSize: CHART_LABEL_FONT_SIZE,
        fontStyle: 'bold',
        fontColor: '#0f172a',
        padding: 16
      }
    },
    title: {
      display: true,
      text: 'مقایسه T4 کارشناسان در ماه‌های مختلف',
      fontColor: '#0f172a',
      fontFamily: CHART_FONT_FAMILY,
      fontSize: CHART_TITLE_FONT_SIZE,
      fontStyle: 'bold',
      padding: 18
    },
    tooltips: {
      mode: 'index',
      intersect: false,
      rtl: true,
      titleAlign: 'right',
      bodyAlign: 'right',
      backgroundColor: 'rgba(15, 23, 42, 0.92)',
      titleFontSize: 13,
      titleFontFamily: CHART_FONT_FAMILY,
      bodyFontFamily: CHART_FONT_FAMILY,
      titleFontStyle: 'bold',
      bodyFontSize: CHART_TOOLTIP_FONT_SIZE,
      xPadding: 12,
      yPadding: 10,
      callbacks: {
        title: (tooltipItems: any[]) => {
          const dataIndex = tooltipItems[0]?.index ?? 0;
          return this.chart2MonthMeta[dataIndex]?.displayLabel ?? '';
        },
        label: (tooltipItem: any) => {
          const monthMeta = this.chart2MonthMeta[tooltipItem.index ?? 0];
          const dataset = this.chart2Data[tooltipItem.datasetIndex ?? 0];
          const lines: string[] = [];

          lines.push(`نام: ${dataset?.label ?? ''}`);

          if (monthMeta) {
            lines.push(`ماه: ${monthMeta.monthName}`);
            lines.push(`سال: ${monthMeta.year}`);
          }

          lines.push(`T4: ${this.formatNumber(Number(tooltipItem.yLabel ?? 0))}`);
          return lines;
        }
      }
    },
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
        offset: 2,
        clamp: true,
        clip: false,
        color: '#1f2937',
        font: {
          family: CHART_FONT_FAMILY,
          size: CHART_LABEL_FONT_SIZE,
          weight: 'bold'
        },
        formatter: (value: number | string | null | undefined) => {
          const numericValue = Number(value ?? 0);
          if (numericValue === 0) {
            return '';
          }
          return this.formatNumber(numericValue);
        },
        display: (context: DataLabelContext) => this.getDataLabelValue(context) !== 0
      }
    },
    scales: {
      xAxes: [
        {
          stacked: false,
          offset: true,
          gridLines: {
            display: false,
            color: '#f1f5f9',
            zeroLineColor: '#cbd5e1'
          },
          ticks: {
            autoSkip: true,
            maxTicksLimit: 14,
            fontFamily: CHART_FONT_FAMILY,
            fontSize: CHART_AXIS_FONT_SIZE,
            fontStyle: 'bold',
            fontColor: CHART_TEXT_COLOR,
            maxRotation: 0,
            minRotation: 0,
            padding: 8
          },
          scaleLabel: {
            display: true,
            labelString: 'ماه ',
            fontFamily: CHART_FONT_FAMILY,
            fontColor: '#334155',
            fontSize: 13,
            fontStyle: 'bold'
          }
        }
      ],
      yAxes: [
        {
          stacked: false,
          gridLines: {
            color: '#e5e7eb',
            zeroLineColor: '#cbd5e1'
          },
          ticks: {
            beginAtZero: true,
            fontFamily: CHART_FONT_FAMILY,
            fontSize: CHART_AXIS_FONT_SIZE,
            fontStyle: 'bold',
            fontColor: CHART_TEXT_COLOR,
            padding: 8,
            callback: (value: string | number) => this.formatNumber(Number(value ?? 0))
          },
          scaleLabel: {
            display: true,
            labelString: 'T4',
            fontFamily: CHART_FONT_FAMILY,
            fontColor: '#334155',
            fontSize: 13,
            fontStyle: 'bold'
          }
        }
      ]
    }
  });

  private readonly numberFormatter = new Intl.NumberFormat('fa-IR', {
    maximumFractionDigits: 2
  });

  private readonly datasetColorCache = new Map<string, DatasetColorPair>();

  constructor(
    private User_Service: UserService,
    private Nav_Service: NavService,
    private Kartable_Service: KartableService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {;

    this.Nav_Service.CheckValidPage(2182).subscribe(
      () => {
        this.Read_User_Option();
      },
      () => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    );
  }

  Read_User_Option() {
    this.Procssing = true;
    this.User_Service.GetRecord().subscribe(
      data => {
        this.DataList_Kartable_Option = data;
        this.Procssing = false;
      },
      () => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    );
  }

  ReadData_Point(StartSearchDate: string, EndSearchDate: string): void {
    this.Procssing = true;
    this.resetCharts();

    this.Kartable_Service.GetDevicePoint2(StartSearchDate,
      EndSearchDate,
      this.DeviceName,
      this.CustomerName,
      Number(this.SubmitPeriodDate),
      Number(this.SubmitAccept),
      Number(this.LocationOfCalibration),
      this.ExpertCalibration
    ).subscribe(
      data => {
        const response = (data ?? {}) as DevicePoint2ApiResponse;

        this.DataList_Kartable = response.reuslt ?? [];
        this.DataList_Calibration = this.DataList_Kartable.filter(item => item.pointType !== 'PM_V2');
        this.DataList_PM_V2 = this.DataList_Kartable.filter(item => item.pointType === 'PM_V2');

        const chart1Result = response.chart1 ?? [];
        const chart2Result = response.chart2 ?? [];
        const workday = response.workday ?? 0;
        this.chart1HorizontalLineValue = workday * 3
        this.chart1HorizontalLineLabel = 'حد مجاز ('+workday+' روزکاری)';
        this.prepareChart1(chart1Result);
        this.prepareChart2(chart2Result);

        this.Procssing = false;
      },
      () => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    );
  }

  prepareChart1(data: Chart1Item[]): void {
    const aggregated = new Map<string, Chart1Item>();

    for (const item of data) {
      const fullName = this.normalizeText(item.fullName) || 'نام نامشخص';
      const totalT4 = Number(item.totalT4) || 0;
      const current = aggregated.get(fullName);

      if (current) {
        current.totalT4 += totalT4;
      } else {
        aggregated.set(fullName, {
          fullName,
          totalT4
        });
      }
    }

    const chart1Rows = Array.from(aggregated.values()).sort((a, b) => {
      const diff = b.totalT4 - a.totalT4;
      if (diff !== 0) {
        return diff;
      }
      return a.fullName.localeCompare(b.fullName, 'fa-IR');
    });

    const labels = chart1Rows.map(item => item.fullName);
    const values = chart1Rows.map(item => this.roundToTwoDecimals(item.totalT4));

    this.chart1HasData = labels.length > 0;
    this.chart1MinWidth = this.calculateChart1MinWidth(labels);
    this.chart1Labels = labels.map(label => this.wrapChartLabel(label, 14));
    this.chart1Data = [
      {
        label: 'T4',
        data: values,
        backgroundColor: 'rgba(37, 99, 235, 0.82)',
        borderColor: '#1d4ed8',
        borderWidth: 1,
        borderSkipped: 'bottom',
        maxBarThickness: 52,
        categoryPercentage: 0.72,
        barPercentage: 0.9
      }
    ];
    this.refreshChart1Scale();
  }

  public updateChart1HorizontalLine(value: number | null): void {
    this.chart1HorizontalLineValue = value !== null && Number.isFinite(value) ? value : null;
    this.refreshChart1Scale();
    this.chart1Directive?.update();
  }

  prepareChart2(data: Chart2Item[]): void {
    const monthMap = new Map<string, { year: number; month: number; monthName: string }>();
    const personMap = new Map<string, { fullName: string; totalsByMonth: Map<string, number>; total: number }>();

    for (const item of data) {
      const fullName = this.normalizeText(item.fullName) || 'نام نامشخص';
      const monthName = this.normalizeText(item.monthName) || `ماه ${item.month}`;
      const year = Number(item.year) || 0;
      const month = Number(item.month) || 0;
      const totalT4 = Number(item.totalT4) || 0;
      const monthKey = this.buildMonthKey(year, month);

      if (!monthMap.has(monthKey)) {
        monthMap.set(monthKey, {
          year,
          month,
          monthName
        });
      }

      const existingPerson = personMap.get(fullName);
      if (existingPerson) {
        existingPerson.total += totalT4;
        existingPerson.totalsByMonth.set(
          monthKey,
          (existingPerson.totalsByMonth.get(monthKey) ?? 0) + totalT4
        );
      } else {
        const totalsByMonth = new Map<string, number>();
        totalsByMonth.set(monthKey, totalT4);
        personMap.set(fullName, {
          fullName,
          totalsByMonth,
          total: totalT4
        });
      }
    }

    const sortedMonthKeys = Array.from(monthMap.entries())
      .sort((first, second) => this.compareMonthKeys(first[1], second[1]))
      .map(([monthKey]) => monthKey);

    const distinctYears = new Set(sortedMonthKeys.map(monthKey => monthMap.get(monthKey)?.year ?? 0));
    const showYearInLabel = distinctYears.size > 1;

    this.chart2MonthMeta = sortedMonthKeys.map(monthKey => {
      const monthInfo = monthMap.get(monthKey);
      const safeMonthInfo = monthInfo ?? { year: 0, month: 0, monthName: '' };
      const displayMonthName = safeMonthInfo.monthName || `ماه ${safeMonthInfo.month}`;

      return {
        year: safeMonthInfo.year,
        month: safeMonthInfo.month,
        monthName: displayMonthName,
        displayLabel: showYearInLabel ? `${displayMonthName} ${safeMonthInfo.year}` : displayMonthName
      };
    });

    const sortedPersons = Array.from(personMap.values()).sort((first, second) => {
      const diff = second.total - first.total;
      if (diff !== 0) {
        return diff;
      }
      return first.fullName.localeCompare(second.fullName, 'fa-IR');
    });

    this.chart2Labels = this.chart2MonthMeta.map(item => item.displayLabel);
    this.chart2Data = sortedPersons.map(person => {
      const color = this.getDatasetColor(person.fullName);
      const values = sortedMonthKeys.map(monthKey => this.roundToTwoDecimals(person.totalsByMonth.get(monthKey) ?? 0));

      return {
        label: person.fullName,
        data: values,
        backgroundColor: color.background,
        borderColor: color.border,
        borderWidth: 1,
        borderSkipped: 'bottom',
        maxBarThickness: 40,
        categoryPercentage: 0.72,
        barPercentage: 0.9
      };
    });

    this.chart2HasData = sortedMonthKeys.length > 0 && this.chart2Data.length > 0;
    this.chart2MinWidth = this.calculateChart2MinWidth(sortedMonthKeys.length, this.chart2Data.length);
  }

  exportexcel(): void {
    this.exportTable('excel-table-calibration', 'BehfaPoint-Calibration.xlsx', 'Calibration');
  }

  exportPMExcel(): void {
    this.exportTable('excel-table-pm', 'BehfaPoint-PM-V2.xlsx', 'PM_V2');
  }

  private exportTable(tableId: string, fileName: string, sheetName: string): void {
    const element = document.getElementById(tableId);
    if (!element) {
      return;
    }

    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, sheetName);
    XLSX.writeFile(wb, fileName);
  }

  OnGet_ExpertCalibration_Action(model: ExpertCalibration_Interface[]) {
    this.ExpertCalibration = '-1';
    for (const item of model) {
      this.ExpertCalibration = `${this.ExpertCalibration},${item.id}`;
    }

    if (model.length === 0) {
      this.ExpertCalibration = '';
    }
  }

  public loadDevicePoint2Years(): void {
    if (this.isLoadingDevicePoint2Years) {
      return;
    }
    this.isLoadingDevicePoint2Years = true;
    this.Kartable_Service.GetDevicePoint2Years(this.DeviceName,
      this.CustomerName,
      Number(this.LocationOfCalibration),
      this.ExpertCalibration
    ).pipe(finalize(() => this.isLoadingDevicePoint2Years = false)).subscribe(
      response => {
        this.devicePoint2YearsLoaded = true;
        this.devicePoint2YearsResponse = response ?? {};
        this.prepareDevicePoint2YearsChart(this.devicePoint2YearsResponse);
      },
      () => {
        this.devicePoint2YearsLoaded = true;
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    );
  }

  public onDevicePoint2YearFullNameChange(): void {
    this.buildDevicePoint2YearsChartForPerson(this.selectedDevicePoint2YearFullName);
  }

  private prepareDevicePoint2YearsChart(response: DevicePoint2YearsResponse): void {
    const current = response.current_Year_chart2 ?? [];
    const last = response.last_Year_chart2 ?? [];
    this.currentYearWorkingValues = response.current_Year_Working?.length
      ? this.buildWorkingValues(response.current_Year_Working)
      : this.buildDistinctWorkingValuesFromChartItems(current);
    this.lastYearWorkingValues = response.last_Year_Working?.length
      ? this.buildWorkingValues(response.last_Year_Working)
      : this.buildDistinctWorkingValuesFromChartItems(last);
    const names = new Map<string, string>();
    [...current, ...last].forEach(item => {
      const displayName = (item.fullName ?? '').trim();
      const normalized = this.normalizeFullName(displayName);
      if (normalized && !names.has(normalized)) {
        names.set(normalized, displayName);
      }
    });
    this.devicePoint2YearFullNames = Array.from(names.values());
    if (!names.has(this.normalizeFullName(this.selectedDevicePoint2YearFullName))) {
      this.selectedDevicePoint2YearFullName = this.devicePoint2YearFullNames[0] ?? '';
    }
    this.buildDevicePoint2YearsChartForPerson(this.selectedDevicePoint2YearFullName);
  }

  private buildDevicePoint2YearsChartForPerson(fullName: string): void {
    const response = this.devicePoint2YearsResponse;
    if (!response || !fullName) {
      this.devicePoint2YearsChartData = [];
      this.devicePoint2YearsChartHasData = false;
      return;
    }
    const current = response.current_Year_chart2 ?? [];
    const last = response.last_Year_chart2 ?? [];
    const currentYear = this.getYear(current) ?? new Date().getFullYear();
    const lastYear = this.getYear(last) ?? currentYear - 1;
    const currentValues = this.buildMonthlyValues(current, this.normalizeFullName(fullName));
    const lastValues = this.buildMonthlyValues(last, this.normalizeFullName(fullName));
    this.devicePoint2YearsChartData = [
      { type: 'bar', data: currentValues, label: `T4 سال جاری ${currentYear}`, yAxisID: 't4-axis', backgroundColor: 'rgba(37, 99, 235, 0.82)', borderColor: '#1d4ed8', borderWidth: 1, order: 2 },
      { type: 'bar', data: lastValues, label: `T4 سال قبل ${lastYear}`, yAxisID: 't4-axis', backgroundColor: 'rgba(16, 185, 129, 0.82)', borderColor: '#047857', borderWidth: 1, order: 2 },
      { type: 'line', data: this.currentYearWorkingValues, label: `ساعت کاری مفید سال ${currentYear}`, yAxisID: 'working-axis', fill: false, tension: 0, pointRadius: 4, pointHoverRadius: 6, borderWidth: 2, borderColor: '#169c2f', backgroundColor: '#169c2f', order: 1 },
      { type: 'line', data: this.lastYearWorkingValues, label: `ساعت کاری مفید سال ${lastYear}`, yAxisID: 'working-axis', fill: false, tension: 0, pointRadius: 4, pointHoverRadius: 6, borderWidth: 2, borderColor: '#9c55d9', backgroundColor: '#9c55d9', order: 1 }
    ];
    this.devicePoint2YearsChartHasData = currentValues.some(value => value !== null) || lastValues.some(value => value !== null);
    this.devicePoint2YearsChartOptions.title = { ...(this.devicePoint2YearsChartOptions.title || {}), display: true, text: `مقایسه T4  برای ${fullName}` };
    this.devicePoint2YearsChartDirective?.update();
  }

  private buildMonthlyValues(items: DevicePoint2YearItem[], normalizedFullName: string): Array<number | null> {
    const values: Array<number | null> = new Array<number | null>(12).fill(null);
    items.filter(item => this.normalizeFullName(item.fullName) === normalizedFullName).forEach(item => {
      const month = Number(item.month);
      const value = Number(item.totalT4);
      if (Number.isInteger(month) && month >= 1 && month <= 12 && Number.isFinite(value)) {
        values[month - 1] = (values[month - 1] ?? 0) + this.roundToTwoDecimals(value);
      }
    });
    return values;
  }

  private buildWorkingValues(items: DevicePoint2WorkingItem[]): Array<number | null> {
    const values: Array<number | null> = new Array<number | null>(12).fill(null);
    items.forEach(item => {
      const month = Number(item.month);
      const working = Number(item.working);
      if (Number.isInteger(month) && month >= 1 && month <= 12 && Number.isFinite(working) && values[month - 1] === null) {
        values[month - 1] = working;
      }
    });
    return values;
  }

  private buildDistinctWorkingValuesFromChartItems(items: DevicePoint2YearItem[]): Array<number | null> {
    return this.buildWorkingValues(items.map(item => ({ year: item.year, month: item.month, monthName: item.monthName, working: item.working }))
      .filter(item => item.working !== undefined) as DevicePoint2WorkingItem[]);
  }

  private getYear(items: DevicePoint2YearItem[]): number | null {
    const year = items.map(item => Number(item.year)).find(value => Number.isInteger(value) && value > 0);
    return year ?? null;
  }

  private normalizeFullName(value: string | null | undefined): string {
    return (value || '').trim().replace(/\s+/g, ' ').replace(/ي/g, 'ی').replace(/ك/g, 'ک');
  }

  /** Keeps the existing Chart.js 2 presentation settings while exposing them
   * in the Chart.js 3 format expected by ng2-charts 4. */
  private convertLegacyChartOptions(options: any): any {
    const toFont = (source: any) => ({
      family: source?.fontFamily,
      size: source?.fontSize,
      weight: source?.fontStyle
    });
    const clean = (value: any) => Object.keys(value || {}).reduce((result: any, key: string) => {
      if (value[key] !== undefined) {
        result[key] = value[key];
      }
      return result;
    }, {});
    const convertAxis = (axis: any) => {
      const { gridLines, scaleLabel, ticks, id, ...axisOptions } = axis;
      const {
        fontFamily, fontSize, fontStyle, fontColor, beginAtZero, ...tickOptions
      } = ticks || {};
      return clean({
        ...axisOptions,
        beginAtZero,
        grid: gridLines ? clean({
          display: gridLines.display,
          color: gridLines.color,
          drawOnChartArea: gridLines.drawOnChartArea,
          borderColor: gridLines.zeroLineColor
        }) : undefined,
        ticks: ticks ? clean({
          ...tickOptions,
          color: fontColor,
          font: clean({ family: fontFamily, size: fontSize, weight: fontStyle })
        }) : undefined,
        title: scaleLabel ? clean({
          display: scaleLabel.display,
          text: scaleLabel.labelString,
          color: scaleLabel.fontColor,
          font: toFont(scaleLabel)
        }) : undefined
      });
    };
    const scales: any = {};
    (options.scales?.xAxes || []).forEach((axis: any, index: number) => {
      scales[axis.id || (index === 0 ? 'x' : `x${index}`)] = convertAxis(axis);
    });
    (options.scales?.yAxes || []).forEach((axis: any, index: number) => {
      scales[axis.id || (index === 0 ? 'y' : `y${index}`)] = convertAxis(axis);
    });

    const legacyTooltip = options.tooltips || {};
    const legacyCallbacks = legacyTooltip.callbacks || {};
    const asLegacyItem = (item: any) => ({
      ...item,
      index: item.dataIndex,
      yLabel: item.parsed?.y
    });
    const tooltipCallbacks = clean({
      title: legacyCallbacks.title
        ? (items: any[]) => legacyCallbacks.title(
          items.map(asLegacyItem), items[0]?.chart?.data
        )
        : undefined,
      label: legacyCallbacks.label
        ? (item: any) => legacyCallbacks.label(asLegacyItem(item), item.chart?.data)
        : undefined
    });
    const {
      titleFontFamily, titleFontSize, titleFontStyle,
      bodyFontFamily, bodyFontSize, bodyFontStyle,
      xPadding, yPadding, callbacks, ...tooltipOptions
    } = legacyTooltip;
    const legendLabels = options.legend?.labels || {};
    const {
      fontFamily: legendFontFamily, fontSize: legendFontSize,
      fontStyle: legendFontStyle, fontColor: legendFontColor,
      ...legendLabelOptions
    } = legendLabels;
    const {
      fontFamily: titleFamily, fontSize: titleSize,
      fontStyle: titleWeight, fontColor: titleColor,
      ...titleOptions
    } = options.title || {};
    const { legend, title, tooltips, responsiveAnimationDuration, ...rootOptions } = options;

    return {
      ...rootOptions,
      animation: { duration: responsiveAnimationDuration || 0 },
      scales,
      plugins: {
        ...(options.plugins || {}),
        legend: legend ? {
          ...legend,
          labels: clean({
            ...legendLabelOptions,
            color: legendFontColor,
            font: clean({ family: legendFontFamily, size: legendFontSize, weight: legendFontStyle })
          })
        } : undefined,
        title: title ? clean({
          ...titleOptions,
          color: titleColor,
          font: clean({ family: titleFamily, size: titleSize, weight: titleWeight })
        }) : undefined,
        tooltip: tooltips ? clean({
          ...tooltipOptions,
          padding: Math.max(xPadding || 0, yPadding || 0) || undefined,
          titleFont: clean({ family: titleFontFamily, size: titleFontSize, weight: titleFontStyle }),
          bodyFont: clean({ family: bodyFontFamily, size: bodyFontSize, weight: bodyFontStyle }),
          callbacks: tooltipCallbacks
        }) : undefined
      }
    };
  }

  private createDevicePoint2YearsChartOptions(): any {
    return this.convertLegacyChartOptions({
      responsive: true,
      maintainAspectRatio: false,
      responsiveAnimationDuration: 200,
      layout: { padding: { top: 18, right: 12, left: 12, bottom: 4 } },
      legend: {
        display: true,
        position: 'bottom',
        rtl: true,
        labels: { boxWidth: 12, fontFamily: CHART_FONT_FAMILY, fontSize: CHART_LABEL_FONT_SIZE, fontStyle: 'bold', fontColor: '#0f172a', padding: 16 }
      },
      title: {
        display: true, fontFamily: CHART_FONT_FAMILY, fontColor: '#0f172a',
        fontSize: CHART_TITLE_FONT_SIZE, fontStyle: 'bold', padding: 18
      },
      tooltips: {
        mode: 'index', intersect: false, rtl: true, titleAlign: 'right', bodyAlign: 'right',
        backgroundColor: 'rgba(15, 23, 42, 0.92)', titleFontFamily: CHART_FONT_FAMILY,
        bodyFontFamily: CHART_FONT_FAMILY, titleFontSize: CHART_TOOLTIP_FONT_SIZE,
        titleFontStyle: 'bold', bodyFontSize: CHART_TOOLTIP_FONT_SIZE, xPadding: 12, yPadding: 10,
        callbacks: {
          title: (items: any[]) => this.persianMonths[items[0]?.index ?? 0],
          label: (item: any) => {
            const datasetLabel = this.devicePoint2YearsChartData[item.datasetIndex ?? 0]?.label ?? '';
            const value = item.yLabel === null || item.yLabel === undefined
              ? 'داده موجود نیست'
              : this.formatNumber(Number(item.yLabel));
            const isWorking = datasetLabel.indexOf('ساعت کاری مفید') >= 0;
            return isWorking
              ? [`ماه: ${this.persianMonths[item.index ?? 0]}`, datasetLabel, `ساعت کاری مفید: ${value}`]
              : [`نام: ${this.selectedDevicePoint2YearFullName}`, `ماه: ${this.persianMonths[item.index ?? 0]}`, datasetLabel, `TotalT4: ${value}`];
          }
        }
      },
      plugins: {
        datalabels: {
          anchor: 'end', align: 'end', offset: 2, clamp: true, clip: false,
          color: '#1f2937', font: { family: CHART_FONT_FAMILY, size: CHART_LABEL_FONT_SIZE, weight: 'bold' },
          formatter: (value: number | string | null | undefined, context: DataLabelContext) => {
            if (value === null || value === undefined || !Number.isFinite(Number(value))) { return ''; }
            const dataset = context.dataset as ChartDataset & { type?: string };
            return dataset.type === 'line'
              ? new Intl.NumberFormat('fa-IR', { maximumFractionDigits: 1 }).format(Number(value))
              : this.formatNumber(Number(value));
          },
          display: (context: DataLabelContext) => {
            const value = context.dataset.data?.[context.dataIndex];
            return value !== null && value !== undefined && Number.isFinite(Number(value));
          }
        }
      },
      scales: {
        xAxes: [{
          stacked: false, offset: true,
          gridLines: { display: false, color: '#f1f5f9', zeroLineColor: '#cbd5e1' },
          ticks: {
            autoSkip: false, fontFamily: CHART_FONT_FAMILY, fontSize: CHART_AXIS_FONT_SIZE,
            fontStyle: 'bold', fontColor: CHART_TEXT_COLOR, maxRotation: 0, minRotation: 0, padding: 8
          },
          scaleLabel: { display: true, labelString: 'ماه', fontFamily: CHART_FONT_FAMILY, fontColor: '#334155', fontSize: 13, fontStyle: 'bold' }
        }],
        yAxes: [{
          id: 't4-axis',
          stacked: false,
          gridLines: { color: '#e5e7eb', zeroLineColor: '#cbd5e1' },
          ticks: {
            beginAtZero: true, fontFamily: CHART_FONT_FAMILY, fontSize: CHART_AXIS_FONT_SIZE,
            fontStyle: 'bold', fontColor: CHART_TEXT_COLOR, padding: 8,
            callback: (value: string | number) => this.formatNumber(Number(value))
          },
          scaleLabel: { display: true, labelString: 'T4', fontFamily: CHART_FONT_FAMILY, fontColor: '#334155', fontSize: 13, fontStyle: 'bold' }
        }, {
          id: 'working-axis', position: 'right',
          gridLines: { drawOnChartArea: false },
          ticks: { beginAtZero: true, suggestedMax: 31, stepSize: 1, fontFamily: CHART_FONT_FAMILY, fontSize: CHART_AXIS_FONT_SIZE, fontStyle: 'bold', fontColor: CHART_TEXT_COLOR, padding: 8, callback: (value: string | number) => this.formatNumber(Number(value)) },
          scaleLabel: { display: true, labelString: 'ساعت کاری مفید', fontFamily: CHART_FONT_FAMILY, fontColor: '#334155', fontSize: 13, fontStyle: 'bold' }
        }]
      }
    });
  }

  modalRef_Baznegari: BsModalRef | undefined;
  Datalist_Baznegari: string[] = [];
  openModal(template: TemplateRef<unknown>, record: string[]) {
    this.Datalist_Baznegari = record;
    this.modalRef_Baznegari = this.modalService.show(template);
  }

  modalRef_Baznegari1: BsModalRef | undefined;
  Datalist_Baznegari1: string[] = [];
  openModal1(template: TemplateRef<unknown>, record: string[]) {
    this.Datalist_Baznegari1 = record;
    this.modalRef_Baznegari1 = this.modalService.show(template);
  }

  private resetCharts(): void {
    this.chart1HasData = false;
    this.chart2HasData = false;
    this.chart1MinWidth = '100%';
    this.chart2MinWidth = '100%';
    this.chart2MonthMeta = [];
    this.chart1Labels = [];
    this.chart2Labels = [];
    this.chart1Data = [];
    this.chart2Data = [];
  }

  private refreshChart1Scale(): void {
    const yAxis = this.chart1Options.scales?.y;
    const ticks = yAxis?.ticks;
    if (!ticks) {
      return;
    }

    let dataMaximum = 0;
    for (const dataset of this.chart1Data) {
      for (const value of dataset.data ?? []) {
        if (typeof value === 'number' && Number.isFinite(value)) {
          dataMaximum = Math.max(dataMaximum, value);
        }
      }
    }
    const lineValue = this.getValidHorizontalLineValue();
    const visibleMaximum = Math.max(dataMaximum, lineValue ?? 0);

    if (visibleMaximum <= 0) {
      delete ticks.max;
      return;
    }

    const padding = Math.max(CHART_SCALE_MIN_PADDING, visibleMaximum * CHART_SCALE_PADDING_RATIO);
    ticks.max = this.roundToTwoDecimals(visibleMaximum + padding);
  }

  private drawChart1HorizontalLine(chart: ChartJs2WithArea): void {
    const lineValue = this.getValidHorizontalLineValue();
    const chartArea = chart.chartArea;
    const yScale = chart.scales?.['y'];
    if (lineValue === null || !chartArea || !yScale) {
      return;
    }

    const yPixel = yScale.getPixelForValue(lineValue);
    if (!Number.isFinite(yPixel) || yPixel < chartArea.top || yPixel > chartArea.bottom) {
      return;
    }

    const context = chart.ctx;
    context.save();
    context.beginPath();
    context.moveTo(chartArea.left, yPixel);
    context.lineTo(chartArea.right, yPixel);
    context.strokeStyle = this.chart1HorizontalLineColor;
    context.lineWidth = Math.max(1, this.chart1HorizontalLineWidth);
    context.setLineDash(this.chart1HorizontalLineDash);
    context.stroke();

    const label = `${this.chart1HorizontalLineLabel}: ${this.formatNumber(lineValue)}`;
    context.font = `bold ${CHART_LABEL_FONT_SIZE}px ${CHART_FONT_FAMILY}`;
    context.textBaseline = 'middle';
    const labelWidth = context.measureText(label).width + HORIZONTAL_LINE_LABEL_PADDING * 2;
    const labelLeft = Math.max(chartArea.left, chartArea.right - labelWidth);
    const labelTop = Math.min(
      chartArea.bottom - HORIZONTAL_LINE_LABEL_HEIGHT,
      Math.max(chartArea.top, yPixel - HORIZONTAL_LINE_LABEL_HEIGHT - 4)
    );

    context.fillStyle = 'rgba(255, 255, 255, 0.94)';
    context.fillRect(labelLeft, labelTop, labelWidth, HORIZONTAL_LINE_LABEL_HEIGHT);
    context.strokeStyle = this.chart1HorizontalLineColor;
    context.setLineDash([]);
    context.strokeRect(labelLeft, labelTop, labelWidth, HORIZONTAL_LINE_LABEL_HEIGHT);
    context.fillStyle = this.chart1HorizontalLineColor;
    context.textAlign = 'right';
    context.fillText(
      label,
      labelLeft + labelWidth - HORIZONTAL_LINE_LABEL_PADDING,
      labelTop + HORIZONTAL_LINE_LABEL_HEIGHT / 2
    );
    context.restore();
  }

  private getValidHorizontalLineValue(): number | null {
    const value = this.chart1HorizontalLineValue;
    return value !== null && value !== undefined && Number.isFinite(value) ? value : null;
  }

  private normalizeText(value: string | null | undefined): string {
    if (!value) {
      return '';
    }

    return value
      .normalize('NFC')
      .replace(/[\u200c\u200d\u200e\u200f\u202a-\u202e\u2066-\u2069\ufeff]/g, '')
      .replace(/[\u064a\u0649]/g, 'ی')
      .replace(/\u0643/g, 'ک')
      .replace(/\s+/g, ' ')
      .trim();
  }

  private formatNumber(value: number): string {
    return this.numberFormatter.format(value);
  }

  private roundToTwoDecimals(value: number): number {
    return Math.round((Number(value) + Number.EPSILON) * 100) / 100;
  }

  private wrapChartLabel(value: string, maxLength: number): string | string[] {
    const normalizedValue = this.normalizeText(value);
    if (!normalizedValue || normalizedValue.length <= maxLength) {
      return normalizedValue;
    }

    const words = normalizedValue.split(' ');
    const lines: string[] = [];
    let currentLine = '';

    for (const word of words) {
      const nextLine = currentLine ? `${currentLine} ${word}` : word;
      if (nextLine.length <= maxLength) {
        currentLine = nextLine;
        continue;
      }

      if (currentLine) {
        lines.push(currentLine);
      }

      if (word.length > maxLength) {
        const chunks = this.chunkText(word, maxLength);
        lines.push(...chunks.slice(0, -1));
        currentLine = chunks[chunks.length - 1] ?? '';
      } else {
        currentLine = word;
      }
    }

    if (currentLine) {
      lines.push(currentLine);
    }

    return lines.length > 0 ? lines : normalizedValue;
  }

  private chunkText(text: string, size: number): string[] {
    const chunks: string[] = [];
    for (let index = 0; index < text.length; index += size) {
      chunks.push(text.slice(index, index + size));
    }
    return chunks;
  }

  private getLabelText(label: unknown): string {
    if (Array.isArray(label)) {
      return label.map(item => String(item)).join(' ');
    }

    return String(label ?? '');
  }

  private getDataLabelValue(context: DataLabelContext): number {
    const value = context.dataset.data?.[context.dataIndex];
    return Number(value ?? 0);
  }

  private buildMonthKey(year: number, month: number): string {
    return `${year}-${String(month).padStart(2, '0')}`;
  }

  private compareMonthKeys(first: { year: number; month: number }, second: { year: number; month: number }): number {
    if (first.year !== second.year) {
      return first.year - second.year;
    }

    return first.month - second.month;
  }

  private getDatasetColor(fullName: string): DatasetColorPair {
    const normalizedName = this.normalizeText(fullName) || 'نام نامشخص';
    const cachedColor = this.datasetColorCache.get(normalizedName);
    if (cachedColor) {
      return cachedColor;
    }

    const hue = this.hashText(normalizedName) % 360;
    const color: DatasetColorPair = {
      background: `hsla(${hue}, 72%, 54%, 0.82)`,
      border: `hsl(${hue}, 72%, 40%)`
    };

    this.datasetColorCache.set(normalizedName, color);
    return color;
  }

  private hashText(value: string): number {
    let hash = 0;
    for (let index = 0; index < value.length; index += 1) {
      hash = (hash * 31 + value.charCodeAt(index)) >>> 0;
    }
    return hash;
  }

  private calculateChart1MinWidth(labels: string[]): string {
    if (labels.length === 0) {
      return '100%';
    }

    const longestLabelLength = labels.reduce((max, label) => Math.max(max, label.length), 0);
    const width = Math.max(900, labels.length * 130, longestLabelLength * 26);
    return `${width}px`;
  }

  private calculateChart2MinWidth(monthCount: number, datasetCount: number): string {
    if (monthCount === 0 || datasetCount === 0) {
      return '100%';
    }

    const width = Math.max(1000, monthCount * Math.max(120, datasetCount * 24));
    return `${width}px`;
  }
}
